module.exports = __webpack_public_path__ + "assets/keypad-sounds/squack-ccdbe80ddb866dd43dee31a0e502f94b.wav";